import { render, staticRenderFns } from "./BannerSection.vue?vue&type=template&id=a0b684ce&scoped=true&"
import script from "./BannerSection.vue?vue&type=script&lang=js&"
export * from "./BannerSection.vue?vue&type=script&lang=js&"
import style0 from "./BannerSection.vue?vue&type=style&index=0&id=a0b684ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0b684ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2065084294/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0b684ce')) {
      api.createRecord('a0b684ce', component.options)
    } else {
      api.reload('a0b684ce', component.options)
    }
    module.hot.accept("./BannerSection.vue?vue&type=template&id=a0b684ce&scoped=true&", function () {
      api.rerender('a0b684ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BannerSection.vue"
export default component.exports